import { render, staticRenderFns } from "./EditReservationModal.vue?vue&type=template&id=90676f80&"
import script from "./EditReservationModal.vue?vue&type=script&lang=js&"
export * from "./EditReservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports